import type { EnrichedSupplierForDelivery } from "../../DeliveryOptions/types";

/** Removes zero-quantity parts and empty splits from delivery-options split payload. */
export function sanitizeSplitData(
  splitData: EnrichedSupplierForDelivery[] = [],
): EnrichedSupplierForDelivery[] {
  return splitData
    .map((split) => ({
      ...split,
      parts: (split?.parts || []).filter(
        (part) => Number(part?.quantity || 0) > 0,
      ),
    }))
    .filter((split) => (split?.parts || []).length > 0);
}
